import actions from './actions';
import mutations from './mutations';

const state = {
  title: '',
  onConfirm: () => {},
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
